let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3PxOJ")).then(() => parcelRequire('ja6eF'));